<template>

</template>

<script>
    import NodeState from "../../components/pagesbuilder/NodeState";

    export default {
        name: "PreviewNodeState",
        mixins: [NodeState],
        computed: {
            bubbles(){
                return true;
            }
        }
    }   
</script>

